import ProfileAppearance from '@/screens/ProfileAppearance';

export default function PrivateProfileAppearanceRoute() {
  return <ProfileAppearance />;
}
